<template>
  <div id="forgot">
    <v-card max-width="400px">
      <v-card-title>Reset Password</v-card-title>
      <v-card-subtitle>Enter email address below.  An email will be sent with a link to reset your password.</v-card-subtitle>
      <v-card-text class="pb-0">
        <v-text-field outlined dense :error-messages="emailError" label="Email" type="email" v-model="email"></v-text-field>
        </v-card-text>
      <v-card-actions class="d-flex justify-space-between px-6">
        <v-btn small text color="secondary" to="/login" replace>Cancel</v-btn>
        <v-btn outlined color="primary" @click="submitForm">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {fa} from '@/db'

export default {
  name: 'Forgot',
  data() {
    return {
      email: null,
      emailError: null,
    }
  },
  computed: {
    
  },
  methods: {
    submitForm() {
      this.emailError = (!this.emailIsValid()) ? 'Invalid email address' : null
      if (!this.emailError) {
        fa.sendPasswordResetEmail(this.email).then(() => {
          this.$store.dispatch('setSnack', 'An email has been sent to ' + this.email)
          this.$router.replace("/login")
        }).catch(error => {
          this.$store.dispatch('setSnack', error.message)
        })
      }
    },
    emailIsValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
    },
  }

}
</script>

<style>

</style>